import React, { useLayoutEffect, useRef, useState } from "react";
import Footer from "../Footer/Footer";
import NavBar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import Axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./BookTour.css";
function BookTour() {
  const url = "https://hgs.mediapattern.com/";
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleScroll = (e) => {
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };
  const [data, setData] = useState({
    Username: "",
    Email: "",
    Mobile: "",
    City: "",
    Grade: "",
    Message: "",
    school: "palla",
  });
  function handle(e) {
    const newdata = { ...data };
    newdata[e.target.id] = e.target.value;
    setData(newdata);
  }

  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    // Section 1
    parentName: "",
    mobile: "",
    email: "",
    relationship: "",
    // Section 2
    childName: "",
    dob: "",
    currentGrade: "",
    interestedGrade: "",
    currentSchool: "",
    // Section 3
    tourDate: "",
    tourTime: "",
    familyMembers: "",
    // Section 4
    referral: "",
    otherReferral: "",
    // Section 5
    consent: false,
  });

  // handle change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // validate per step
  const validateStep = () => {
    let newErrors = {};
    if (step === 1) {
      if (!formData.parentName) newErrors.parentName = "Full name is required";
      if (!formData.mobile.match(/^[0-9]{10,}$/))
        newErrors.mobile = "Enter a valid mobile number";
      if (!formData.email.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/))
        newErrors.email = "Enter a valid email address";
      if (!formData.relationship)
        newErrors.relationship = "Please select relationship";
    }
    if (step === 2) {
      if (!formData.childName) newErrors.childName = "Child’s name is required";
      if (!formData.dob) newErrors.dob = "Date of birth is required";
      if (!formData.interestedGrade)
        newErrors.interestedGrade = "Interested grade is required";
    }
    if (step === 3) {
      if (!formData.tourDate) newErrors.tourDate = "Select a preferred date";
      if (!formData.tourTime) newErrors.tourTime = "Select a time slot";
      if (
        !formData.familyMembers ||
        formData.familyMembers < 1 ||
        formData.familyMembers > 2
      )
        newErrors.familyMembers = "Enter 1 or 2 members only";
    }
    if (step === 4) {
      if (!formData.referral) newErrors.referral = "Please select an option";
      if (formData.referral === "Other" && !formData.otherReferral)
        newErrors.otherReferral = "Please specify";
    }
    if (step === 5) {
      if (!formData.consent)
        newErrors.consent = "You must agree before submitting";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // step navigation
  const nextStep = () => {
    if (validateStep()) setStep((prev) => prev + 1);
  };
  const prevStep = () => setStep((prev) => prev - 1);

  // final submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateStep()) {
      submit(e);
    }
  };

  function formatForMail(data) {
    return Object.entries(data)
      .map(([key, value]) => `${key} : ${value}`)
      .join("</br>");
  }

  function submit(e) {
    setLoading(true);

    let message = formatForMail(formData);

    Axios.post(url, {
      username: formData.parentName,
      email: formData.email,
      mobile: formData.mobile,
      city: '',
      grade: formData.currentGrade,
      school: 'palla',
      message: message,
    }).then((res) => {
      console.log(res.data);
      if (res.data.message === "Email Sent") {
        setSuccess(true);
        setLoading(false);
        toast.success(
          "Your Query has been recieved successfully, we will contact you",
          {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
        setData({
          Username: "",
          Email: "",
          Mobile: "",
          City: "",
          Grade: "",
          Message: "",
          school: "palla",
        });
      } else {
        setLoading(false);
      }
    });
  }

  return (
    <div className="home_main" onScroll={handleScroll}>
      <NavBar handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      {success && (
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      )}
      <div className="contactus_main">

        <div className="container my-5 col-lg-8">
          <div className="card shadow-lg p-4 rounded-4" style={{
            background: "linear-gradient(120deg, rgb(30 154 214 / 0%) 0%, rgb(194 233 251 / 45%) 100%)"
          }}>
            {success == true && (<>
              <h1 className="text-center m-4">Thank you for booking a tour with HGS. We’ll confirm your visit shortly.</h1>
            </>)}

            {success == false && (<>
            
            <h2 className="text-center mb-4">Book a School Tour</h2>
              <form onSubmit={handleSubmit} noValidate>
                {/* Progress */}
                <div className="mb-4">
                  <div className="progress" style={{ height: "8px" }}>
                    <div
                      className="progress-bar contact-bar"
                      style={{
                        width: `${(step / 5) * 100}%`,
                        background: "#1E9AD6 !important",
                        background: "linear-gradient(111deg, rgb(0 12 18) 0%, rgb(19 109 171 / 74%) 59%, rgb(30 154 214) 100%)",
                      }}
                    ></div>
                  </div>
                  <p className="text-center small mt-2">Step {step} of 5</p>
                </div>

                {/* Step 1 */}
                {step === 1 && (
                  <>
                    <h4 className="mb-3">Parent / Guardian Details</h4>
                    <div className="mb-3">
                      <label className="form-label">Full Name</label>
                      <input
                        type="text"
                        className={`form-control ${errors.parentName ? "is-invalid" : ""
                          }`}
                        name="parentName"
                        value={formData.parentName}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">{errors.parentName}</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Mobile Number</label>
                      <input
                        type="tel"
                        className={`form-control ${errors.mobile ? "is-invalid" : ""
                          }`}
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">{errors.mobile}</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email Address</label>
                      <input
                        type="email"
                        className={`form-control ${errors.email ? "is-invalid" : ""
                          }`}
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">{errors.email}</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Relationship to Child</label>
                      <select
                        className={`form-select ${errors.relationship ? "is-invalid" : ""
                          }`}
                        name="relationship"
                        value={formData.relationship}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        <option>Mother</option>
                        <option>Father</option>
                        <option>Guardian</option>
                        <option>Other</option>
                      </select>
                      <div className="invalid-feedback">{errors.relationship}</div>
                    </div>
                  </>
                )}

                {/* Step 2 */}
                {step === 2 && (
                  <>
                    <h4 className="mb-3">Student Details</h4>
                    <div className="mb-3">
                      <label className="form-label">Child’s Full Name</label>
                      <input
                        type="text"
                        className={`form-control ${errors.childName ? "is-invalid" : ""
                          }`}
                        name="childName"
                        value={formData.childName}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">{errors.childName}</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Date of Birth</label>
                      <input
                        type="date"
                        className={`form-control ${errors.dob ? "is-invalid" : ""}`}
                        name="dob"
                        value={formData.dob}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">{errors.dob}</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Current Grade / Class</label>
                      <input
                        type="text"
                        className="form-control"
                        name="currentGrade"
                        value={formData.currentGrade}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Interested Grade</label>
                      <input
                        type="text"
                        className={`form-control ${errors.interestedGrade ? "is-invalid" : ""
                          }`}
                        name="interestedGrade"
                        value={formData.interestedGrade}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">{errors.interestedGrade}</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Current School</label>
                      <input
                        type="text"
                        className="form-control"
                        name="currentSchool"
                        value={formData.currentSchool}
                        onChange={handleChange}
                      />
                    </div>
                  </>
                )}

                {/* Step 3 */}
                {step === 3 && (
                  <>
                    <h4 className="mb-3">Tour Preferences</h4>
                    <div className="mb-3">
                      <label className="form-label">Preferred Date</label>
                      <input
                        type="date"
                        className={`form-control ${errors.tourDate ? "is-invalid" : ""
                          }`}
                        name="tourDate"
                        value={formData.tourDate}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">{errors.tourDate}</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Preferred Time Slot</label>
                      <select
                        className={`form-select ${errors.tourTime ? "is-invalid" : ""
                          }`}
                        name="tourTime"
                        value={formData.tourTime}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        <option>Morning</option>
                        <option>Afternoon</option>
                        <option>Evening (8am - 3pm)</option>
                      </select>
                      <div className="invalid-feedback">{errors.tourTime}</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Number of Family Members (Max 2)
                      </label>
                      <input
                        type="number"
                        min="1"
                        max="2"
                        className={`form-control ${errors.familyMembers ? "is-invalid" : ""
                          }`}
                        name="familyMembers"
                        value={formData.familyMembers}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">{errors.familyMembers}</div>
                    </div>
                  </>
                )}

                {/* Step 4 */}
                {step === 4 && (
                  <>
                    <h4 className="mb-3">How did you hear about us?</h4>
                    <select
                      className={`form-select ${errors.referral ? "is-invalid" : ""
                        }`}
                      name="referral"
                      value={formData.referral}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option>Social Media</option>
                      <option>Website</option>
                      <option>Word of Mouth</option>
                      <option>Existing Parent</option>
                      <option>Other</option>
                    </select>
                    <div className="invalid-feedback">{errors.referral}</div>

                    {formData.referral === "Other" && (
                      <div className="mb-3 mt-3">
                        <label className="form-label">Please specify</label>
                        <input
                          type="text"
                          className={`form-control ${errors.otherReferral ? "is-invalid" : ""
                            }`}
                          name="otherReferral"
                          value={formData.otherReferral}
                          onChange={handleChange}
                        />
                        <div className="invalid-feedback">
                          {errors.otherReferral}
                        </div>
                      </div>
                    )}
                  </>
                )}

                {/* Step 5 */}
                {step === 5 && (
                  <>
                    <h4 className="mb-3">Final Step</h4>
                    <div className="form-check mb-3">
                      <input
                        className={`form-check-input ${errors.consent ? "is-invalid" : ""
                          }`}
                        type="checkbox"
                        name="consent"
                        id="consentcheckbox"
                        checked={formData.consent}
                        onChange={handleChange}
                      />
                      <label className="form-check-label" for="consentcheckbox">
                        I agree to be contacted by HGS for tour
                        confirmation and admission updates.
                      </label>
                      <div className="invalid-feedback">{errors.consent}</div>
                    </div>
                    <button type="submit" className="btn btn-success w-100">
                      Book My Tour
                    </button>
                  </>
                )}

                {/* Navigation */}
                <div className="d-flex justify-content-between mt-4">
                  {step > 1 && (
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={prevStep}
                    >
                      ← Back
                    </button>
                  )}
                  {step < 5 && (
                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      onClick={nextStep}
                    >
                      Next →
                    </button>
                  )}
                </div>
              </form>
            </>)}
          </div>
        </div>

      </div>
      <Footer />
    </div>
  );
}

export default BookTour;
